module.exports = __webpack_public_path__ + "img/casa_thumb.e7025fe9.jpg";